// AutoReplaceBye.js
import { Extension } from '@tiptap/core';

export const ExtendExtension = (shortcutsList) => {
  let currentShortcuts = shortcutsList;
  return Extension.create({
    name: 'autoReplace',
    addOptions() {
      return {
        getShortcuts: () => currentShortcuts,
        setShortcuts: (newList) => {
          currentShortcuts = newList;
        },
      };
    },
    addKeyboardShortcuts() {
      const replaceShortcut = () => {
        const shortcuts = this.options.getShortcuts();
        console.log(shortcuts);
        if (shortcuts.length < 1) {
          return false;
        }
        const { state } = this.editor;
        const { $from } = state.selection;
        const nodeBefore = $from.nodeBefore?.text || '';

        const match = shortcuts.find((item) => {
          let escape = item?.label;
          escape = escape.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const safeRegex = new RegExp(escape, 'g');
          const res = safeRegex.exec(nodeBefore);
          if (res !== null) {
            return res;
          }
        });
        if (!match || !match?.content) {
          return false;
        }
        const replacement = match?.content;
        if (!replacement) {
          return false;
        }
        this.editor
          .chain()
          .deleteRange({
            from: $from.pos - (match.label.length + 1),
            to: $from.pos,
          })
          .insertContent(' ' + replacement + ' ')
          .run();
        return true;
      };
      return {
        Space: () => replaceShortcut(),
        Enter: () => replaceShortcut(),
      };
    },
  });
};
